rjm.ui.ChartBuilderCohortFieldView = Backbone.View.extend(
  id: "cbCohortField"
  className: "span"

  events:
    "change #cohortFieldList": "changeCohortField"

  initialize: (options) ->
    if not options or not options.chartModel or not options.cohortFieldCollection
      throw "InvalidConstructorArgs - ChartBuilderCohortFieldView"

    _.bindAll this, "changeCohortField", "generateTemplateData", "render", "blockView"

    @chartModel = options.chartModel
    @cohortDescriptor = @chartModel.getCurrentSeries().get('cohortDescriptor')
    @cohortFieldCollection = options.cohortFieldCollection
    @isTooltipVisible = false

    @listenTo @cohortFieldCollection, "reset", =>
      if @cohortDescriptor.get("cohortField") is null
        @cohortDescriptor.set
          cohortField: @cohortFieldCollection.first()
        @chartModel.getCurrentSeries().change() #HACK: this will kick of a preview render if we entered cohort mode
      @render()

    @listenTo @chartModel.getCurrentSeries(), "change:dataPerspective", @render

    return

  changeCohortField: (e) ->
    e.preventDefault()
    newCohortFieldId = $(e.target).val()
    @chartModel.getCurrentSeries().changeCohortField(@cohortFieldCollection.get(newCohortFieldId))

    return

  generateTemplateData: (data) ->
    return cohortFields: @cohortFieldCollection.toJSON()

  cohortFieldIsDisabled: (cohortFieldId) ->
    dataPerspective = @chartModel.get('series').at(0).get('dataPerspective')
    if (dataPerspective is rjm.app.enums.dataPerspective.PER_COHORT_MEMBER or 
        dataPerspective is rjm.app.enums.dataPerspective.CUMULATIVE_PER_COHORT_MEMBER) and 
        not @cohortFieldCollection.get(cohortFieldId).get("canCountMembers")
      return true
    return false

  blockView: ->
    @$("#s2id_cohortFieldList").addClass("blocked loading")

  toggleTooltip: ->
    @$("#s2id_cohortFieldList").find("b").tooltip "toggle"
    @isTooltipVisible = not @isTooltipVisible

  render: ->
    @$("#s2id_cohortFieldList").find("b").tooltip "destroy"
    @$el.html ich.chartBuilderCohortField(@generateTemplateData())

    @$("#cohortFieldList").select2
      placeholder: "Choose a Cohort Field"
      dropdownCssClass: "bigdrop"
      width: "225px"

    @$("#cohortFieldList").select2("val", @cohortDescriptor.get("cohortField")?.get("id"))

    if @cohortFieldCollection.size() is 0
      @blockView()

    return @
)
